export default __webpack_public_path__ + "static/media/darkluna.e1552612.mp4";